import { withField, withRow } from 'components/InputsUtils';
import { WrappedInputProps } from 'components/InputsUtils/types';
import TextareaComponent from './Textarea';

const Textarea = withRow(withField<WrappedInputProps>(TextareaComponent));

export default Textarea;
